module.exports = __webpack_public_path__ + "img/371.72fb5a90.jpg";